module.exports = __webpack_public_path__ + "img/diners.645ccabf.svg";